var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import closeServiceEntryRetroactively from '../../requests/service/closeServiceEntryRetroactively';
/**
 *
 */
var CloseServiceEntryRetroactivelyCommand = /** @class */ (function (_super) {
    __extends(CloseServiceEntryRetroactivelyCommand, _super);
    function CloseServiceEntryRetroactivelyCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param data Object
     * @param organisation OrganisationModel
     * @param serviceEntryModel ServiceSchemaModel
     * @param serviceEntryCollection ServiceEntryCollection
     * @param intl
     * @return {*}
     */
    CloseServiceEntryRetroactivelyCommand.prototype.execute = function (data, organisation, serviceEntryModel, serviceEntryCollection, intl) {
        this.intl = intl;
        this.serviceEntryModel = serviceEntryModel;
        this.serviceEntryCollection = serviceEntryCollection;
        var promise = closeServiceEntryRetroactively(data, organisation, serviceEntryModel);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    CloseServiceEntryRetroactivelyCommand.prototype.then = function (response) {
        this.serviceEntryCollection.remove(this.serviceEntryModel);
        Signals.ServiceEntryClosed.dispatch(this.serviceEntryModel);
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.service.entry.closed' }, {}), 'dark', true);
    };
    return CloseServiceEntryRetroactivelyCommand;
}(Command));
export default CloseServiceEntryRetroactivelyCommand;
